import createIcon from '../../createIcon';

/**
 * @component @name ViewColumn
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNjcgNVYxOUg5LjMzVjVIMTQuNjdaTTE1LjY3IDE5SDIxVjVIMTUuNjdWMTlaTTguMzMgMTlWNUgzVjE5SDguMzNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ViewColumn = createIcon('ViewColumn', [
  [
    'path',
    { d: 'M14.67 5V19H9.33V5H14.67ZM15.67 19H21V5H15.67V19ZM8.33 19V5H3V19H8.33Z', key: 'pil37g' },
  ],
]);

export default ViewColumn;
